import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CmsLinkComponent, WindowRef } from '@spartacus/core';
import { CmsComponentData, MediaContainer } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import '../../../model/link.model';

export interface GgGridExtendedItemComponent {
  uid: string;
  itemTitle: string;
  subtitle: string;
  description?: string;
  image?: MediaContainer;
  mobileImage?: MediaContainer;
  link?: CmsLinkComponent;
  link2?: CmsLinkComponent;
  styleClasses?: string;
  linkToItemId?: string;
}

@Component({
  selector: 'app-gg-grid-extended-item',
  templateUrl: 'gg-grid-extended-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GgGridExtendedItemComponent {
  private componentData = inject(CmsComponentData<GgGridExtendedItemComponent>);
  private winRef = inject(WindowRef);

  data$: Observable<GgGridExtendedItemComponent> = this.componentData.data$;

  scrollTo(id: string): void {
    if (this.winRef.isBrowser()) {
      const scrollElement = this.winRef.document.getElementById(id);
      scrollElement?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
  }

  getTarget(target: string | boolean | undefined): string | null {
    return target === 'true' || target === true ? '_blank' : null;
  }
}
